import {
  createContext,
  useCallback,
  useState,
  useSyncExternalStore,
} from "react";
import API from "services/api";

export const MasterDataContext = createContext({});

const MasterDataProvider = (props) => {
  const [users, setUsers] = useState([]);
  const [dataUser, setDataUser] = useState({});
  const [roles, setRoles] = useState([]);
  const [dataRole, setDataRole] = useState({});

  const [listPermissions, setListPermissions] = useState([]);

  const getListPermissions = useCallback(async () => {
    await API.getListPermissions()
      .then((res) => {
        const data = res.data;
        setListPermissions(data);
      })
      .catch((err) => console.log("err", err));
  }, [listPermissions]);

  const getUsers = useCallback(
    async (params) => {
      await API.getAllUser(params)
        .then((res) => {
          const { data } = res;
          // console.log("data", res.data);
          setUsers(data);
        })
        .catch((err) => console.log("err", err));
    },
    [users]
  );

  const getRoles = useCallback(
    async (params) => {
      await API.getRoles(params).then((res) => {
        const { data } = res;
        setRoles(data);
      });
    },
    [roles]
  );

  const getDataUser = useCallback(async (id, params) => {
    await API.getUser(id, params)
      .then((res) => {
        const { data } = res.data;
        // console.log("Data ", data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  return (
    <MasterDataContext.Provider
      value={{
        users,
        roles,
        dataRole,
        dataUser,
        listPermissions,

        getUsers,
        getRoles,
        getDataUser,
        getListPermissions,
      }}
      {...props}
    />
  );
};

export default MasterDataProvider;
